import React, { useEffect, useState } from "react";
import { colors } from "../../views/Landing";
import Chart from "react-apexcharts";
import "../.././styling/charts.css";

const ProfitGraph = ({ dateList, allData, stream, color }) => {
  const seriesAllData = Object.keys(allData).map((info, index) => {
    const data = dateList?.map((yDate) => {
      if (Object.keys(allData[info]).includes(yDate)) {
        return Number(allData[info][yDate][1].toFixed().toLocaleString());
      }
      return 0;
    });
    return { name: info, data, colors: colors[index] };
  });

  function tickFormat(d) {
    const date = new Date(d);
    return (
      date.toLocaleString("default", { month: "short" }) + " " + date.getDate()
    );
  }

  const options = {
    chart: {
      height: 400,
      type: "line",
      toolbar: {
        tools: {
          download: false,
          selection: false,
          zoom: false,
          zoomin: true,
          zoomout: true,
          pan: false,
          reset: true,
        },
      },
      zoom: {
        enabled: true,
      },
      animations: {
        enabled: false,
      },
    },
    title:{
      text:"My Profit Over Time",
      style: {
        fontSize:  '20px',
        fontWeight:  'bold',
      },
      offsetY : 8,
      align:"center",
    },
    dataLabels: {
      enabled: false,
    },
    grid: {
      padding: {
        top: 40,
      },
    },
    colors:
      stream === -1
        ? seriesAllData.map((item) => item.colors)
        : [color],
    stroke: {
      show: true,
      lineCap: "butt",
      curve: "straight",
      width:2
    },
    legend: {
      itemMargin: {
        horizontal: 30,
        vertical: 15,
      },
    },
    labels: dateList.map((d) => tickFormat(d)),
    tooltip: {
      y: {
        formatter: function (
          value,
          { series, seriesIndex, dataPointIndex, w }
        ) {
          return Number(value).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          });
        },
      },
    },
    markers: {
      size: 0,
      hover: {
        sizeOffset: 6,
      },
    },
    xaxis: {
      title: {
        text: "Time (month)",
        offsetX: 300,
        offsetY: 90,
        style: {
          fontSize: 15,
        },
      },
      tooltip: {
        enabled: false,
      },
      labels:{
        rotate: 0
      },
      tickAmount: dateList.length > 10 ? 4 : dateList.length
    },
    annotations: {
      xaxis: [
        {
          x:dateList.map((d) => tickFormat(d)).length == 1 && dateList.map((d) => tickFormat(d))[0],
          borderColor: '#00E396',
          label: {
            borderColor: '#00E396',
            style: {
              color: '#fff',
              background: '#00E396'
            }
          }
        }
      ]
    },
    yaxis: {
      title: {
        text: "Profit ($)",
        rotate: 0,
        offsetX: 30,
        offsetY: -150,
        style: {
          fontSize: 15,
        },
      },
      labels: {
        formatter: function (val, index) {
          return val.toLocaleString();
        },
      },
    },
    responsive: [
      {
        breakpoint: 1400,
        options: {
          grid: {
            padding: {
              top: 15,
              right: 10,
            },
          },
          xaxis: {
            title: {
              text: "Time (month)",
              offsetX: 250,
              offsetY: dateList.length > 10 ? 130 : 85,
              style: {
                fontSize: 16,
                cssClass: "apexcharts-yaxis-title",
              },
            },
          },
          yaxis: {
            title: {
              text: "Profit ($)",
              rotate: 0,
              offsetX: 30,
              offsetY: -155,
              style: {
                fontSize: 16,
              },
            },
            labels: {
              formatter: function (val, index) {
                return val.toLocaleString();
              },
            },
          },
        },
      },
      {
        breakpoint: 1360,
        options: {
          yaxis: {
            title:{
              text: "Profit ($)",
              rotate: 0,
              offsetX: 30,
              offsetY: -140,
              style: {
                fontSize: 16,
              }
            }
          }
        }
      }
    ],
  };
  useEffect(() => {
    if (seriesAllData.length <= 1) {
      const apexToolTip = document.getElementsByClassName("apexcharts-tooltip")
    }
  },[])
  return (
    <div id="charts">
      <Chart
        // @ts-ignore
        options={options}
        series={seriesAllData}
        type="line"
        height={400}
      />
    </div>
  );
};

export default ProfitGraph;
